<template>
    <div class="panel__container">
        <user-invitations @back="goBack" :message="message" action="channel/inviteMembers">
            <template slot="invite_users_title">Invite guests to {{ channel.name }}</template>
            <template slot="confirmation_label">To be invited to the channel <strong>{{ channel.name }}</strong></template>
        </user-invitations>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import UserInvitations from '../../../Global/Users/UserInvitations'

export default {
    data () {
        return {
            message: ''
        }
    },

    created () {
        this.message = `${this.currentUser.display_name} invited you to join the channel '${this.channel.name}' on Skybase.`
    },

    methods: {
        goBack () {
            this.$router.push({ path: `/channel/${this.channel.slug}/settings/people/options` })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('channel', {
            channel: 'channel'
        })
    },

    components: {
        UserInvitations
    }
}
</script>
